// router/index.js
import { createBrowserRouter, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Main from '../views/Main';
import Inicio from '../views/Main/components/Inicio';
import MovsView from '../views/Main/components/Movimientos';
import FactsView from '../views/Main/components/Facturas';
import AbonosView from '../views/Main/components/Abonos';
import DashBoardView from '../views/Main/components/Dashboard';
import MicuentaView from '../views/Main/components/Micuenta';
import BackOfficeView from '../views/Main/components/Backoffice';
import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import User from '../models/user';

const InitialRedirect = () => {
    const { keycloak, initialized } = useKeycloak();
    const user = initialized && keycloak.authenticated ? new User(keycloak.token, keycloak.tokenParsed) : null;

    if (!initialized) {
        return <div>Cargando...</div>;
    }

    if (!keycloak.authenticated) {
        return <Navigate to="/login" replace />; // Asegúrate de tener una ruta de login
    }

    if (user?.company === "Recomotor") {
        return <Navigate to="/movimientos" replace />;
    } else if (user?.company === "Desguace Mical" || user?.company === "Desguace Segohon") {
        return <Navigate to="/facturas" replace />;
    } else {
        // Puedes definir una ruta por defecto para otras compañías o mostrar un mensaje
        return <Navigate to="/mi-cuenta" replace />; // Ejemplo de redirección por defecto
    }
};

export const router = createBrowserRouter([
    {
        path: '/',
        element: <ProtectedRoute><Main /></ProtectedRoute>,
        loader: ({ request }) => {
            return null;
        },
        shouldRevalidate: () => true,
        children: [
            { path: "*", exact: true, element: <Navigate to="/" /> },
            {
                path: "/",
                element: <ProtectedRoute><InitialRedirect /></ProtectedRoute>,
            },
            {
                path: "/cargarMovimientos",
                element: <ProtectedRoute allowedCompanies={["Recomotor"]}><Inicio /></ProtectedRoute>,
            },
            {
                path: "/movimientos",
                element: <ProtectedRoute allowedCompanies={["Recomotor"]}><MovsView /></ProtectedRoute>,
            },
            {
                path: "/facturas",
                element: <ProtectedRoute allowedCompanies={["Recomotor", "Desguace Mical", "Desguace Segohon"]}><FactsView /></ProtectedRoute>,
            },
            {
                path: "/abonos",
                element: <ProtectedRoute allowedCompanies={["Recomotor", "Desguace Mical", "Desguace Segohon"]}><AbonosView /></ProtectedRoute>,
            },
            {
                path: "/exportadores",
                element: <ProtectedRoute allowedCompanies={["Recomotor"]}><DashBoardView /></ProtectedRoute>,
            },
            {
                path: "/backoffice",
                element: <ProtectedRoute allowedCompanies={["Recomotor"]}><BackOfficeView /></ProtectedRoute>,
            },
            {
                path: "/mi-cuenta",
                element: <ProtectedRoute allowedCompanies={["Recomotor", "Desguace Mical", "Desguace Segohon"]}><MicuentaView /></ProtectedRoute>,
            },
        ],
    },
]);